import { Component } from "react";
import { AUTOCOMPLETE } from "../../../../../../actions/manageFeedsAction";
import AccountPicker from "../Elements/AccountPicker";
import CheckBoxField from "../Elements/CheckboxField";
import InfoSection from "../Elements/InfoSection";
import InputField from "../Elements/InputField";
import { DEBOUNCE } from "../../../../../../utils";

class TwTabs extends Component {
    state = {
        showList: false,
        lists: [],
    }

    autoComplete = DEBOUNCE((e) => {
        AUTOCOMPLETE({
            networkId: 1,
            handle: e.target.value,
        }).then(res => {
            const { data } = res
            if (data.responseCode == 200) {
                this.setState({ lists: data.responseData, showList: true })
            }
            else this.setState({ lists: [], showList: false })
        })
    })

    handleAutoComplete = (e) => {
        this.props.onChangeHandler(e);

        if(e.target.value && e.target.value.length > 0){
            this.autoComplete(e);
        }
    }

    onSelectList = (item) => {
        const { onListNameChange, onListIdChange } = this.props;
        onListNameChange(item.name);
        onListIdChange(item.id, item.owner_id);
        this.setState({ showList: false })
    }

   
    render() {
        const {lists, showList } = this.state
        const { tab, moderation, excludeRetweet, listName, listNameError, userName, onChangeHandler, excludeReplies, onCheckFieldChange, networkId, connetedAccount, onConnectedAccountChange, multiplePhoto, filter, showError, handleError, mentionError, favoriteError, hashtag, handle, mentions, advanced, favorites, advanceError, showListError, connectedAcc } = this.props;

        const cdate = new Date();
        cdate.setDate(cdate.getDate() - 6);
        const datetime = new Date().toISOString();
        const utc = new Date(datetime);
        utc.setUTCHours(utc.getHours() - 5); // Adjust for Central Standard Time (America/Chicago)

        
        return (
            <>
                <div className="row">
                    {tab != 'list' ? <div className={`col-md-12`}>
                        <div className="form-group">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className={`fas fa-${tab == 'hashtag' ? 'hashtag' : tab == "advanced" ? 'search' : 'at'}`}></i>
                                    </span>
                                </div>
                                <InputField autocomplete={true} id={`twitter_${tab}`}  name={tab}  className={`autosearch mycheck form-control`} placeholder={tab !== "advanced" ? `Enter ${tab !== 'favorites' ? tab : 'the twitter handle of the user to import Liked Posts from.'}` : 'Query'} value={tab == "hashtag" ? hashtag : tab == "handle" ? handle : tab == "mentions" ? mentions : tab == "advanced" ? advanced : favorites}  onChangeHandler={onChangeHandler} />

                                 {(tab == "hashtag" && showError) || (handleError && tab == "handle") || (mentionError && tab == "mentions") || (favoriteError && tab == "favorites") || (advanceError && tab == "advanced") ? <span className="errorMessage required">This field is required.</span> : null}
                                
                            </div>
                        </div>
                    </div> : <>
                        <div className={`col-md-6`}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-list`}></i>
                                        </span>
                                    </div>
                                    <InputField autocomplete={true} id={`twitter_${tab}`} name={"userName"} className={`autosearch mycheck form-control`} placeholder="Enter Keyword" value={userName} onChangeHandler={e => this.handleAutoComplete(e)} />
                                    {showList ? lists && lists.length > 0 ? lists.map((item, index) => (
                                        <li key={item.id} onClick={() => this.onSelectList(item)}>
                                            <div className="content-section">
                                                {item.name}
                                                <p>https://twitter.com/{item.name}</p>
                                            </div>
                                        </li>
                                    )) : null : null}
                                    {showListError && <span className="errorMessage required">This field is required.</span>}
                                    {(tab == "hashtag" && showError) || (handleError && tab == "handle") || (mentionError && tab == "mentions") || (favoriteError && tab == "favorites") || (advanceError && tab == "advanced") ? <span className="invalid-feedback">This field is required.</span> : null}
                                </div>
                            </div>
                        </div>
                        <div className={`col-md-6`}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-list`}></i>
                                        </span>
                                    </div>
                                    <InputField autocomplete={true} name={"listName"} className={`autosearch mycheck form-control`} placeholder="Enter Username" value={listName} onChangeHandler={onChangeHandler} />
                                    {listNameError && <span className="invalid-feedback">This field is required.</span>}
                                </div>
                            </div>
                        </div></>

                    }
                </div>

                {tab == "advanced" ?
                    <div className="w-100 my-3" style={{ height: "250px", overflowY: "auto" }}>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}><strong>Filter By:</strong></th>
                                        <th><strong>Example</strong></th>
                                        <th><strong>Targets Tweets:</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="bold">
                                            <i className="far fa-comment"></i>
                                            Keywords
                                        </td>
                                        <td style={{ width: "166px" }}>grapes banana</td>
                                        <td>containing both "grapes" and "banana".</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>"good time"</td>
                                        <td>containing the exact phrase "good time"</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>die OR alive</td>
                                        <td>containing either "die" or "alive" (or both)</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>food -drink</td>
                                        <td>containing "food" but not "drink"</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>#soul</td>
                                        <td>containing the hashtag "#soul"</td>
                                    </tr>
                                    {/* <tr>
                                        <td className="bold"></td>
                                        <td>service :) </td>
                                        <td>containing "service" and with a positive attitude.</td>
                                    </tr>
                                    <tr>
                                        <td className="bold"></td>
                                        <td>service :( </td>
                                        <td>containing "service" and with a negative attitude.</td>
                                    </tr>
                                    <tr>
                                        <td className="bold"><i className="fas fa-mobile-alt"></i> Questions</td>
                                        <td>weather ?</td>
                                        <td>containing "weather" and asking a question.</td>
                                    </tr> */}
                                    <tr>
                                        <td className="bold"><i className="fas fa-user"></i> User</td>
                                        <td>from:taggbox</td>
                                        <td>sent from the user @taggbox</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>to:taggbox</td>
                                        <td>sent to the user @taggbox</td>
                                    </tr>
                                    <tr>
                                        <td><strong></strong></td>
                                        <td>@taggbox</td>
                                        <td>mentioning @taggbox</td>
                                    </tr>
                                    {/* <tr>
                                        <td className="bold">
                                            <i className="fas fa-location-arrow"></i>
                                            Location
                                        </td>
                                        <td>#dogs geocode:34.0522342,-118.2436849,10km</td>
                                        <td>
                                            containing hashtag "#dogs" within Los Angeles Get coordinates (10km radius)
                                            <a tabIndex="-1" target="_blank" href="https://www.gps-coordinates.org/">here</a>
                                        </td>
                                    </tr>
                                    <tr style={{ display: "none" }}>
                                        <td className="bold">
                                            <i className="fas fa-mobile-alt"></i>
                                            Devices / Apps
                                        </td>
                                        <td>news source:instagramfeed</td>
                                        <td>
                                            containing "news" and entered via InstagramFeed
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td>
                                            <strong>
                                                <i className="fas fa-link"></i>
                                                Content
                                            </strong>
                                        </td>
                                        <td>funny filter:links</td>
                                        <td>containing " funny" and with a URL.</td>
                                    </tr>
                                    <tr>
                                        <td className="bold"><i className="fa fa-calendar"></i> Dates</td>
                                        <td>champion&start_time={cdate.toISOString()}</td>
                                        <td>containing "champion" and sent since date "{cdate.toISOString()}" (year-month-day).</td>
                                    </tr>
                                    <tr>
                                        <td className="bold"></td>
                                        <td>champion&end_time={utc.toISOString()}</td>
                                        <td>containing "champion" and sent before the date "{utc.toISOString()}".</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> : null
                }
                <div className="checkbox-inline mb-2">
                    <CheckBoxField isChecked={multiplePhoto} onChangeHandler={(e) => onCheckFieldChange(e)} name={"multiplePhoto"} id={`feedmultiplephoto_${tab}`} text={'Add Multiple Photos'} />
                </div>
                <div className="checkbox-inline mb-2">
                    <CheckBoxField isChecked={excludeRetweet} onChangeHandler={(e) => onCheckFieldChange(e)} name={"excludeRetweet"} id={`feedretweets_${tab}`} text={'Exclude Retweets'} />
                </div>
                {filter != 3 ?
                    <div className="checkbox-inline mb-2 excludeRepliesAdd">
                        <CheckBoxField isChecked={excludeReplies} onChangeHandler={(e) => onCheckFieldChange(e)} name={"excludeReplies"} id={`feedreplies_${tab}`} text={'Exclude Replies'} />
                    </div>
                    : null}
                <div className="hideforBSearch">
                    <div className="checkbox-inline">
                        <CheckBoxField isChecked={moderation} onChangeHandler={(e) => onCheckFieldChange(e)} name={"moderation"} id={`feedscreatemoderation_${tab}`} />
                    </div>
                </div>
                {connectedAcc && connectedAcc.length ? <AccountPicker connectedAcc={connectedAcc} networkId={networkId} onConnectedAccountChange={onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                {tab != 'list' && tab != "advanced" && tab != "favorites" ?
                    <InfoSection text={tab == 'hashtag' ? `Only 30 tweets will be aggregated from the last 7 days' data, after which all the upcoming tweets will be aggregated.` : tab == 'handle' ? `Initially, 30 tweets will be aggregated from the Twitter handle, after which all the upcoming tweets will be aggregated.` : tab == 'mentions' ? `Only 30 mentions from the last 7 days will be aggregated, after which all the upcoming tweets will be aggregated.` : ``} />
                    : null
                }
            </>
        )
    }
}

export default TwTabs;